import { useLocation } from 'react-router-dom';

export const useQueryParams = () => new URLSearchParams(useLocation().search);

export const getLoginRedirectParam = (location) => {
  const signInSuccessUrl = encodeURIComponent(`${location.pathname}${location.search}`);

  return `signInSuccessUrl=${signInSuccessUrl}`;
};
